const state = {
    visible:false,
    markInfoVisble:false
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
